import type { HTMLAttributes, ReactNode } from 'react';
import { COULEURS_STATUT, styleBase, type StatutBadge, type Variante } from '../tokens/tokens.js';

export const LIBELLES_STATUT: Record<StatutBadge, string> = {
  verifie: 'Vérifié',
  hypothese: 'Hypothèse',
  a_verifier: 'À vérifier',
  en_cours: 'En cours',
  termine: 'Terminé',
  bloque: 'Bloqué',
  en_attente: 'En attente',
  equipe_maat: 'Visible : équipe MAAT',
  masquee_famille: 'Masquée pour la famille',
};

/** Statuts qui doivent se distinguer du « vérifié » autrement que par la couleur (UX-30) : contour en pointillés. */
const INCERTAINS: ReadonlySet<StatutBadge> = new Set<StatutBadge>(['hypothese', 'a_verifier']);

export interface BadgeStatutProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'style' | 'children'> {
  statut: StatutBadge;
  variante?: Variante;
  /** Libellé libre (« Bloqué depuis 14 j ») ; par défaut, le libellé du statut. */
  libelle?: ReactNode;
}

export function BadgeStatut({ statut, variante = 'equipe', libelle, ...attributs }: BadgeStatutProps) {
  const couleurs = COULEURS_STATUT[statut];
  return (
    <span
      {...attributs}
      data-statut={statut}
      style={{
        ...styleBase(variante),
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '2px 12px',
        borderRadius: 999,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color: couleurs.texte,
        backgroundColor: couleurs.fond,
        border: INCERTAINS.has(statut) ? `1px dashed ${couleurs.texte}` : '1px solid transparent',
      }}
    >
      <span
        aria-hidden="true"
        data-pastille=""
        style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: 'currentColor', flex: 'none' }}
      />
      {libelle ?? LIBELLES_STATUT[statut]}
    </span>
  );
}
